import {
    ORGANIZATION_LIST_REQUESTED,
    ORGANIZATION_REQUESTED,
    ORGANIZATION_SPOTS_REQUESTED,
} from 'contexts/OrganizationsContext/constants';
import {
    LOGIN_REQUESTED,
    PROFILE_REQUESTED,
    SPOT_LIST_REQUESTED,
    REPORTS_REQUESTED,
    PROMO_CODE_REPORTS_REQUESTED,
    SEND_VERIFICATION_CODE_REQUESTED,
    SPOT_MULTIDAY_PRICING_REQUESTED,
    UPDATE_REPORTS_REQUESTED,
    LOGOUT_REQUESTED,
    UPDATE_IS_DEMO_MODE,
} from './constants';
import { DateFilter } from 'services/ReportsService';

interface LoginCredentials {
    username: string;
    password: string;
}

export function loginAction(userCredentials: LoginCredentials) {
    return { type: LOGIN_REQUESTED, payload: userCredentials };
}

export function sendVerificationCodeAction(username: string, phoneCode: string) {
    return { type: SEND_VERIFICATION_CODE_REQUESTED, payload: { username, phoneCode } };
}

export function logoutAction() {
    return { type: LOGOUT_REQUESTED };
}

export function getProfileAction() {
    return { type: PROFILE_REQUESTED };
}

export function getOrganizationAction(orgId: number) {
    return { type: ORGANIZATION_REQUESTED, payload: { orgId } };
}

export function getOrganizationsAction() {
    return { type: ORGANIZATION_LIST_REQUESTED };
}

export function getSpotListAction() {
    return { type: SPOT_LIST_REQUESTED };
}

export function getSpotsAction() {
    return { type: ORGANIZATION_SPOTS_REQUESTED };
}

export function getSpotMultidayPricingAction(days: number) {
    return { type: SPOT_MULTIDAY_PRICING_REQUESTED, payload: { days } };
}

export function getReportsAction(filters?: { date: { month: number; year: number } }) {
    return { type: REPORTS_REQUESTED, payload: { filters: filters } };
}

export function updateReportsAction() {
    return { type: UPDATE_REPORTS_REQUESTED };
}

export function getPromoCodeReportsAction(filters: { date: DateFilter }) {
    return { type: PROMO_CODE_REPORTS_REQUESTED, payload: { filters: filters } };
}

export function updateIsDemoModeAction(isDemoMode: boolean) {
    return { type: UPDATE_IS_DEMO_MODE, payload: { isDemoMode } };
}
